import { render, staticRenderFns } from "./TaxiDriverInfo.vue?vue&type=template&id=180568d8&scoped=true"
import script from "./TaxiDriverInfo.vue?vue&type=script&lang=js"
export * from "./TaxiDriverInfo.vue?vue&type=script&lang=js"
import style0 from "./TaxiDriverInfo.vue?vue&type=style&index=0&id=180568d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180568d8",
  null
  
)

export default component.exports